<template>
  <section class="d-flex flex-column justify-center align-center">
    <h2
      v-if="!hasPartner && hasServicer"
      class="sn-h2"
    >
      {{ servicer.full_name }}
    </h2>
    <h2
      v-if="hasPartner"
      class="sn-h2"
    >
      My Home Team
    </h2>
    <div
      v-if="!hasPartner && hasServicer"
      class="d-flex flex-wrap justify-center sn-caption sn-text-primary-01"
    >
      <p v-if="formattedNMLS">
        {{ formattedNMLS }}
      </p>
      <p
        v-if="formattedNMLS"
        class="mr-1 ml-1"
      >
        |
      </p>
      <p
        class="about-link"
        @click="dialogOpenHandler(true)"
      >
        {{ avatarMoreInfo }}
      </p>
    </div>
    <div
      v-if="hasPartner"
      class="d-flex flex-wrap justify-center"
    >
      <div class="d-flex justify-center sn-caption sn-text-primary-01">
        <p
          class="about-link"
          @click="dialogOpenHandler(true)"
        >
          {{ servicer.full_name }}
        </p>
        <p class="mr-1 ml-1">
          |
        </p>
        <p
          class="about-link"
          @click="dialogOpenHandler(false)"
        >
          {{ partner.full_name }}
        </p>
      </div>
    </div>

    <contact-info-dialog
      v-if="hasServicer"
      id="servicer-dialog"
      v-model="dialogServicerOpen"
      :person="servicer"
    />
    <contact-info-dialog
      v-if="hasPartner"
      id="partner-dialog"
      v-model="dialogPartnerOpen"
      :person="partner"
    />
  </section>
</template>

<script>
import { formatNMLS } from '../../Shared/formatNMLS.js'
import { NullServicer, NullPartner } from './nullProfile'
import ContactInfoDialog from '../../Dialogs/ContactInfoDialog.vue'

export default {
  name: 'ServicerInfo',
  components: {
    ContactInfoDialog
  },
  props: {
    servicer: {
      type: Object,
      required: true,
      default: () => new NullServicer()
    },
    partner: {
      type: Object,
      required: false,
      default: () => new NullPartner()
    }
  },
  data () {
    return {
      dialogPartnerOpen: false,
      dialogServicerOpen: false
    }
  },
  computed: {
    formattedNMLS () {
      const nmls = this.servicer?.license || this.partner?.license
      return formatNMLS(nmls)
    },
    hasServicer () {
      return this.servicer?.__typename === 'PublicServicerProfile'
    },
    hasPartner () {
      return this.partner?.__typename === 'PublicPartner'
    },
    avatarMoreInfo () {
      return this.$store?.borrowerWebContent?.avatarMoreInfo
    }
  },
  methods: {
    dialogOpenHandler (servicer = true) {
      if (servicer) {
        this.dialogServicerOpen = true
      } else {
        this.dialogPartnerOpen = true
      }
    }
  },
  formatNMLS
}
</script>

<style scoped>
  h2 {
    text-align: center;
  }

  .about-link {
    cursor: pointer;
    text-decoration: underline;
  }
</style>
